// ./src/config/submissionStatues.ts
import { MantineColor } from "@mantine/core";

export const SUBMISSION_STATUSES = {
  RECEIVED: 50,
  REVIEWED: 100,
  ACCEPTED: 200,
  DECLINED: 300,
  SPAM: 10,
  BLOCKED: 20,
};

export interface StatusConfig {
  label: string;
  color: MantineColor;
  icon: string;
}

export const STATUS_CONFIG: Record<number, StatusConfig> = {
  [SUBMISSION_STATUSES.SPAM]: {
    label: "Spam",
    color: "error",
    icon: "ShieldCancel",
  },
  [SUBMISSION_STATUSES.BLOCKED]: {
    label: "Blocked",
    color: "error",
    icon: "ShieldCancel",
  },
  [SUBMISSION_STATUSES.RECEIVED]: {
    label: "Received",
    color: "accent",
    icon: "Inbox",
  },
  [SUBMISSION_STATUSES.REVIEWED]: {
    label: "Reviewed",
    color: "brand",
    icon: "Eye",
  },
  [SUBMISSION_STATUSES.ACCEPTED]: {
    label: "Accepted",
    color: "success",
    icon: "CircleCheck",
  },
  [SUBMISSION_STATUSES.DECLINED]: {
    label: "Declined",
    color: "warning",
    icon: "CircleX",
  },
};
